var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerformanceIcon = function SvgPerformanceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 4.674V1h1v6h-6V6h4.662A10 10 0 0 0 11 1C5.477 1 1 5.477 1 11q0 .507.05 1H.044A11 11 0 0 1 0 11C0 4.925 4.925 0 11 0c3.72 0 7.01 1.847 9 4.674M2.338 16A10 10 0 0 0 11 21c5.523 0 10-4.477 10-10q0-.507-.05-1h1.005q.045.495.045 1c0 6.075-4.925 11-11 11-3.72 0-7.01-1.847-9-4.674V21H1v-6h6v1z",
    clipRule: "evenodd"
  })));
};
export default SvgPerformanceIcon;